<template>
    <div>
        <button class="button-blue button-blue--small" style="float: right;" v-if="listingView === 'map'" @click="toggleView">Liste</button>
        <button class="button-blue button-blue--small" style="float: right;" v-if="listingView === 'list'" @click="toggleView"><icon class="smaller-svg icon-filter" name="maplocation" />Kort</button>

        <template v-if="requisitionsLoading">
            <h1><div class="count-blinker"></div> entreprenøropgaver</h1>
        </template>
        <template v-else-if="requisitions && requisitions.length > 0">
            <h1>{{ requisitions[0].rowCount }} entreprenøropgave<template v-if="requisitions.length > 1">r</template></h1>
            <p><em>{{ requisitionsSummary }}</em></p>
        </template>
        <template v-else>
            <h1>Ingen entreprenøropgaver</h1>
        </template>

        <div class="list-filter" v-if="activeFilters" >
            <div class="list-filter-group">
                <template v-if="supplyTypes && supplyTypes.length > 1">
                    <div class="list-filter-item" v-for="supplyType in supplyTypes" :key="supplyType.sysBusinessAreaTypeId" v-if="getFilters.supplyType.includes(supplyType.sysBusinessAreaTypeId)" :class="'list-filter-item--' + supplyType.systemName">
                        <span class="list-filter-item-label">Forretningsområde:</span><span class="list-filter-item-value"><icon class="tiny-svg" :name="supplyType.systemName" />{{ supplyType.description }}</span>
                        <button class="list-filter-item-button" @click="removeSupplyTypeFilter(supplyType.sysBusinessAreaTypeId)">
                            <span class="visually-hidden">Fjern filter</span>
                            <span aria-hidden="true">&#10761;</span>
                        </button>
                    </div>
                </template>

                <div class="list-filter-item" v-if="getFilters.address">
                    <span class="list-filter-item-label">Adresse:</span><span class="list-filter-item-value">{{ getFilters.address }}</span>
                    <button class="list-filter-item-button" @click="removeAddressFilter()">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item list-filter-item--alert" v-if="getFilters.kpi === 'requisitionsOverdue'">
                    <span class="list-filter-item-value">Entreprenøropgaver overskredet</span>
                    <button class="list-filter-item-button" @click="removeKPIFilter()">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item list-filter-item--alert" v-if="getFilters.kpi === 'requisitionsOpen'">
                    <span class="list-filter-item-value">Mine entreprenøropgaver</span>
                    <button class="list-filter-item-button" @click="removeKPIFilter()">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.showApproved">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis kun godkendte</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('showApproved')">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.dateOverdue">
                    <span class="list-filter-item-label">Tidsfrist:</span><span class="list-filter-item-value">Overskredet</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('dateOverdue')">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-for="responsible in getFilters.requisitions.responsible" :key="responsible">
                    <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible) ? caseworkers.find(item => item.userId === responsible).name : null }}</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('responsible', responsible)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <template v-if="getFilters.kpi !== 'requisitionsOverdue' && getFilters.kpi !== 'requisitionsOpen'">
                    <div class="list-filter-item" v-for="company in getFilters.requisitions.company" :key="company">
                        <span class="list-filter-item-label">Virksomhed:</span><span class="list-filter-item-value">{{ firms.find(item => item.id === company).name }}</span>
                        <button class="list-filter-item-button" @click="removeRequisitionFilter('company', company)">
                            <span class="visually-hidden">Fjern filter</span>
                            <span aria-hidden="true">&#10761;</span>
                        </button>
                    </div>
                </template>

                <template v-if="getFilters.kpi !== 'requisitionsOverdue' && getFilters.kpi !== 'requisitionsOpen'">
                    <div class="list-filter-item" v-for="contact in getFilters.requisitions.contact" v-if="users.find(item => item.userId === contact)" :key="contact">
                        <span class="list-filter-item-label">Medarbejder:</span><span class="list-filter-item-value">{{ users.find(item => item.userId === contact).name }}</span>
                        <button class="list-filter-item-button" @click="removeRequisitionFilter('contact', contact)">
                            <span class="visually-hidden">Fjern filter</span>
                            <span aria-hidden="true">&#10761;</span>
                        </button>
                    </div>
                </template>

                <div class="list-filter-item" v-for="activityType in getFilters.requisitions.activityType" :key="activityType">
                    <span class="list-filter-item-label">Aktivitetstype:</span><span class="list-filter-item-value">{{ activityTypesList.find(item => item.id === activityType).area }}, {{ activityTypesList.find(item => item.id === activityType).name }}</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('activityType', activityType)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-for="statusType in getFilters.requisitions.statusType" :key="statusType">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">{{ statusTypes.find(item => item.systemName === statusType).description }}</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('statusType', statusType)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.name">
                    <span class="list-filter-item-label">Opgavenavn:</span><span class="list-filter-item-value">{{ getFilters.requisitions.name }}</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('name')">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.startDate.from || getFilters.requisitions.startDate.to">
                    <span class="list-filter-item-label">Startdato<template v-if="getFilters.requisitions.startDate.from && !getFilters.requisitions.startDate.to"> efter</template><template v-if="!getFilters.requisitions.startDate.from && getFilters.requisitions.startDate.to"> før</template>:</span>
                    <span class="list-filter-item-value">
                        <template v-if="getFilters.requisitions.startDate.from && getFilters.requisitions.startDate.to">
                            {{ getFilters.requisitions.startDate.from | formatDateShort }} - {{ getFilters.requisitions.startDate.to | formatDateShort }}
                        </template>
                        <template v-if="getFilters.requisitions.startDate.from && !getFilters.requisitions.startDate.to">
                            {{ getFilters.requisitions.startDate.from | formatDateShort }}
                        </template>
                        <template v-if="!getFilters.requisitions.startDate.from && getFilters.requisitions.startDate.to">
                            {{ getFilters.requisitions.startDate.to | formatDateShort }}
                        </template>
                    </span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('startDate', getFilters.requisitions.startDate.from || getFilters.requisitions.startDate.to)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.requisitions.serialNumber">
                    <span class="list-filter-item-label">Løbenummer:</span><span class="list-filter-item-value">{{ getFilters.requisitions.serialNumber }}</span>
                    <button class="list-filter-item-button" @click="removeRequisitionFilter('serialNumber')">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>
            </div>
        </div>

        <pagination v-show="listingView === 'list' && requisitions && requisitions.length > 0 && requisitions[0].pageCount > 1 && !requisitionsLoading" :showPaging="requisitions && requisitions.length > 0 && requisitions[0].pageCount > 1 ? true : false" :totalPages="requisitions && requisitions.length > 0 ? requisitions[0].pageCount : null" :page="'requisitions'" :position="'right'" />

        <template v-if="listingView === 'list'">
            <div v-if="requisitions && requisitions.length > 0 && !requisitionsLoading" class="grid-x list-sort">
                <div class="cell large-1 hide-for-small-only"></div>
                <div class="cell small-6 large-2">
                    <button :aria-selected="currentSort === 'address1'" @click="sort('address1')">Adresse<icon v-if="currentSort === 'address1'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'address1'}" name="keyboard_arrow_sort" /></button>
                </div>
                <div class="cell large-2 hide-for-small-only">
                    <button :aria-selected="currentSort === 'sentToUser'" @click="sort('sentToUser')">Entreprenør<icon v-if="currentSort === 'sentToUser'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'sentToUser'}" name="keyboard_arrow_sort" /></button>
                </div>
                <div class="cell large-2 hide-for-small-only">
                    <button :aria-selected="currentSort === 'activityList'" @click="sort('activityList')">Aktiviteter<icon v-if="currentSort === 'activityList'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'activityList'}" name="keyboard_arrow_sort" /></button>
                </div>
                <div class="cell small-4 large-2">
                    <button :aria-selected="currentSort === 'nextStartDate'" @click="sort('nextStartDate')">Startdato<icon v-if="currentSort === 'nextStartDate'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'nextStartDate'}" name="keyboard_arrow_sort" /></button>
                </div>
                <div class="cell large-2 hide-for-small-only">
                    <button :aria-selected="currentSort === 'ownerUser'" @click="sort('ownerUser')">Ansvarlig<icon v-if="currentSort === 'ownerUser'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'ownerUser'}" name="keyboard_arrow_sort" /></button>
                </div>
                <div class="cell small-1 large-1">
                    <button :aria-selected="currentSort === 'status'" @click="sort('status')">Status<icon v-if="currentSort === 'status'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'status'}" name="keyboard_arrow_sort" /></button>
                </div>
            </div>
            <transition-group name="list" tag="div" class="mobile-list" v-if="!requisitionsLoading">
                <div class="grid-x list-row supply align-items mobile-text" :class="businessAreaClass(requisition.businessAreaTypeId)" v-for="requisition in requisitions" :key="requisition.requisitionId">
                    <div class="cell large-1 hide-for-small-only">
                        <icon class="task-check-svg medium-svg fill-primary" name="task-check" />
                    </div>
                    <div class="requisition-serialNumber">{{ requisition.serialNumber }}</div>
                    <div class="cell small-6 large-2 item truncate-fade">
                        <span v-if="requisition.address1">{{ requisition.address1 }}</span>
                        <span v-else>Ingen adresse</span>
                        <span>{{ requisition.taskName }}</span>
                    </div>
                    <div class="cell large-2 hide-for-small-only item truncate-fade">
                        <span>{{ requisition.sentToUser }}</span>
                        <span>{{ requisition.sentToOrganization }}</span>
                    </div>
                    <div class="cell large-2 hide-for-small-only item truncate-fade">
                        <span>{{ requisition.activityList }}</span>
                        <span>{{ requisition.objectActivityDoneCount }} af {{ requisition.objectActivityCount }} er udført ({{ requisition.objectActivityDonePercentage }}%)</span>
                    </div>
                    <div class="cell small-4 large-2 item truncate-fade hide-for-small-only" :class="{'flexbox-align-items': !requisition.nextStartDate && !requisition.nextLatestDate || requisition.nextStartDate && !requisition.nextLatestDate}">
                        <span v-if="requisition.nextStartDate"><span>Start: </span>{{ requisition.nextStartDate | formatDateShortElapsed }}</span>
                        <span v-else-if="requisition.nextLatestDate"><span>Slut: </span>{{ requisition.nextLatestDate | formatDateShortElapsed }}</span>
                        <span v-if="!requisition.nextStartDate && !requisition.nextLatestDate"><span style="font-size: 0.9rem; color: #82868d; font-weight: 400;">Ingen dato</span></span>
                        <span :class="{'overdue-alert-red': dateOverdue(requisition.nextLatestDate) && requisition.status.toLowerCase() !== 'færdigmeldt'}" v-else-if="requisition.nextLatestDate"><span>Tidsfrist: {{ requisition.nextLatestDate | formatDateShortElapsed }}</span></span>
                        <!-- <span v-else-if="!requisition.nextLatestDate">Tidsfrist: Ingen</span> -->
                    </div>
                    <div class="cell small-4 large-2 item truncate-fade flexbox-align-items show-for-small-only">
                        <span v-if="requisition.nextStartDate">{{ requisition.nextStartDate | formatDateShortElapsed }}</span>
                        <span v-else-if="requisition.nextLatestDate">{{ requisition.nextLatestDate | formatDateShortElapsed }}</span>
                        <span v-if="!requisition.nextStartDate && !requisition.nextLatestDate"><span>Ingen dato</span></span>
                    </div>
                    <div class="cell large-2 hide-for-small-only item truncate-fade">
                        <span>{{ requisition.ownerUser }}</span>
                        <span>{{ requisition.ownerOrganization }}</span>
                    </div>
                    <div class="cell large-1 item flexbox-center hide-for-small-only double-status">
                        <span class="requisition-status" :class="statusColor(requisition.status)">{{ requisition.status }}</span>
                        <span class="hide-for-small-only">{{ requisition.statusDate | formatDateShortElapsed }}</span>
                    </div>
                    <div class="small-2 show-for-small-only item text-center margin-auto">
                        <span class="truncate-ellipse">{{requisition.status}}</span>
                    </div>
                    <router-link class="dashboard-list-link" :to="{ name: 'requisitionid', params: { id: requisition.requisitionId } }">
                        <span class="visually-hidden">Åben henvendelse</span>
                    </router-link>
                </div>
            </transition-group>
            <pagination v-show="listingView === 'list' && requisitions && requisitions.length > 0 && requisitions[0].pageCount > 1 && !requisitionsLoading" :showPaging="requisitions && requisitions.length > 0 && requisitions[0].pageCount > 1 ? true : false" :totalPages="requisitions && requisitions.length > 0 ? requisitions[0].pageCount : null" :page="'requisitions'" :position="'right'" />
        </template>
        <template v-if="listingView === 'map'">
            <base-map v-if="!requisitionsLoading" style="height: 500px;" ref="baseMap" class="list-map-wrapper" :config="mapConfig" :supplyCode="selectedSupplyType.code" :supplyTypeId="selectedSupplyType.id" :resizer="false" :isRequisitionMap="true" />
        </template>

        <div class="dashboard-list-empty" v-if="!requisitionsLoading && requisitions && requisitions.length === 0">
            <template v-if="activeFilters">
                <h2>Ingen entreprenøropgaver, prøv at ændre en af følgende ting:</h2>
                <ul>
                    <li v-if="getFilters.supplyType.length < supplyTypes.length">Vælg et andet forretningsområde</li>
                    <li v-if="getFilters.requisitions.company.length > 1 || getFilters.requisitions.contact.length > 1 || getFilters.requisitions.responsible.length > 1">Vælg en anden ansvarlig, virksomhed eller entreprenør</li>
                    <li v-if="getFilters.address">Fjern søgning efter adresse</li>
                    <li>Fjern et eller flere filtre</li>
                </ul>
            </template>
            <template v-else>
                <p><em>Ingen entreprenøropgaver oprettet endnu...</em></p>
            </template>
        </div>

        <div class="text-center dashboard-list-loading" v-if="requisitionsLoading || !requisitions">
            Indlæser entreprenøropgaver...
            <div class="list-loader">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="visually-hidden">Indlæser...</div>
            </div>
        </div>

        <router-link :to="{name: 'map'}" title="Åbn stort kort" class="map-button flexbox-center show-for-small-only">
            <icon class="medium-svg fill-white stroke-white" name="maplocation" />
        </router-link>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from '@/components/shared/pagination/pagination.vue'
import baseMap from '@/components/shared/map/base-map.vue'
import { NMapConfig, NMapFeature, NMapStyleIcon, NMapCoordinates, NMapPopup } from 'ncomponents-map'

export default {
    name: 'list-requisition',
    components: {
        pagination,
        'base-map': baseMap
    },
    props: {
        value: Array
    },
    data () {
        return {
            listingView: 'list',
            requisitions: this.value,
            mapConfig: null
        }
    },
    computed: {
        ...mapGetters({
            currentSortDir: 'getCurrentRequisitionOrderByDescending',
            currentSort: 'getCurrentRequisitionOrderByColumnName',

            requisitionsLoading: 'getRequisitionLoading',
            userInfo: 'userInfo',
            selectedSupplyType: 'selectedSupplyType',
            getRequisitionMapItems: 'getRequisitionMapItems',

            // Filters
            supplyTypes: 'getBusinessAreaTypes',
            caseworkers: 'caseWorkerList',
            firms: 'getAllFirmsForActivity',
            users: 'getAllUsersInFirmForActivity',
            activityTypes: 'getCActivityTypeList',
            statusTypes: 'getSysRequisitionAndReportStatusList',
            getFilters: 'getFilters',

            statusTypeList: 'getSysRequisitionStatusTypeList'
        }),

        supplyTypesFormatted () {
            let formatted = ''

            this.supplyTypes.forEach((supplyType, index) => {
                if (index > 0) {
                    formatted += ', '
                }
                formatted += supplyType.description
            })

            return formatted
        },
        activityTypesList () {
            const activityTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.activityTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((activityType) => {
                    activityTypeList.push({
                        id: activityType.typeId,
                        name: activityType.description,
                        area: supplyType.description
                    })
                })
            })

            return activityTypeList
        },
        activeFilters () {
            if (this.getFilters.kpi === 'requisitionsOverdue' || this.supplyTypes.length > 1 || this.getFilters.address || this.getFilters.requisitions.name || (this.getFilters.requisitions.responsible && this.getFilters.requisitions.responsible.length > 0) || (this.getFilters.tasks.contact && this.getFilters.tasks.contact.length > 0) || (this.getFilters.requisitions.company && this.getFilters.requisitions.company.length > 0) || (this.getFilters.requisitions.activityType && this.getFilters.requisitions.activityType.length > 0) || this.getFilters.requisitions.startDate.from || this.getFilters.requisitions.startDate.to || this.getFilters.requisitions.dateOverdue || (this.getFilters.requisitions.statusType && this.getFilters.requisitions.statusType.length > 0) || this.getFilters.requisitions.showApproved) {
                return true
            }

            return false
        },

        requisitionsSummary () {
            const current = this.requisitions[0].currentCount
            const readyForApproval = this.requisitions[0].readyForApprovalCount
            let formatted = ''

            if (current > 0) {
                formatted += current + ' igangværende'
            }
            if (current > 0 && readyForApproval > 0) {
                formatted += ', '
            }
            if (readyForApproval > 0) {
                formatted += readyForApproval + ' færdigmeldt'
                if (readyForApproval > 1) {
                    formatted += 'e'
                }
            }

            return formatted
        }
    },
    watch: {
        value (requisitions) {
            this.requisitions = requisitions
        },

        getFilters: {
            deep: true,
            handler () {
                this.getFilteredList()
            }
        }
    },
    methods: {
        ...mapActions({
            getRequisitions: 'getQueryRequisitionList',
            setActivePages: 'setActivePages',
            setFilters: 'setFilters',
            removeFilters: 'removeFilters',
            resetFilters: 'resetFilters'
        }),

        sort (property) {
            let sort = this.currentSortDir
            const filterObject = {
                orderByDescending: this.currentSort !== property ? false : sort = !sort,
                orderByColumnName: property,
                tab: 'requisitions',
                page: 1
            }

            this.setActivePages(filterObject)
        },
        businessAreaClass (businessAreaType) {
            return this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType).systemName
        },
        statusColor (status) {
            if (status) {
                if (status.toLowerCase() === 'ny') {
                    return 'red-status'
                }
                if (status.toLowerCase() === 'accepteret') {
                    return 'blue-status'
                }
                if (status.toLowerCase() === 'færdigmeldt') {
                    return 'green-status'
                }
                if (status.toLowerCase() === 'godkendt') {
                    return 'purple-status'
                }
                if (status.toLowerCase() === 'afsluttet') {
                    return 'gray-status'
                }
                if (status.toLowerCase() === 'kaldt tilbage') {
                    return 'brown-status'
                }
            }
            return 'blue-status'
        },
        dateOverdue (date) {
            if (window['moment'](date).isBefore(window['moment'](new Date()), 'day')) {
                return true
            }

            return false
        },
        getFilteredList (isFirstLoad) {
            const filter = this.getFilters.requisitions
            const requisitionQuery = {}

            if (filter.name) {
                requisitionQuery.whereLikeTaskName = filter.name
            }
            if (filter.responsible) {
                requisitionQuery.whereOwnerUserIdList = filter.responsible
            }
            if (filter.contact) {
                requisitionQuery.whereSentToUserIdList = filter.contact.length > 0 ? filter.contact : null
            }
            if (filter.company) {
                requisitionQuery.whereSentToOrganizationIdList = filter.company.length > 0 ? filter.company : null
            }
            if (filter.activityType) {
                requisitionQuery.whereActivityTypeIdList = filter.activityType
            }
            if (filter.startDate.from) {
                requisitionQuery.whereAfterStartDate = filter.startDate.from
            }
            if (filter.startDate.to) {
                requisitionQuery.whereBeforeLatestDate = filter.startDate.to
            }
            if (filter.dateOverdue) {
                requisitionQuery.whereOverdue = filter.dateOverdue
            }
            if (filter.statusType) {
                requisitionQuery.whereRequisitionAndReportStatusList = filter.statusType
            }
            if (filter.showApproved) {
                requisitionQuery.whereReportIsApproved = filter.showApproved
            }

            if (this.getFilters.kpi) {
                requisitionQuery.kpiFilter = this.getFilters.kpi
            }

            if (this.getFilters.supplyType) {
                requisitionQuery.whereBusinessAreaTypeIdList = this.getFilters.supplyType
            }

            if (this.getFilters.address) {
                requisitionQuery.whereLikeAddress = this.getFilters.address
            }

            requisitionQuery.showMap = this.listingView === 'map'
            this.getRequisitions(requisitionQuery)
        },
        removeSupplyTypeFilter (value) {
            if (this.getFilters.supplyType.length === 1) {
                this.$notify({
                    group: 'info',
                    type: 'warn',
                    text: 'Der skal være valgt minimum et forretningsområde.',
                    duration: 7500
                })
                return
            }

            this.removeFilters({
                filter: 'supplyType',
                value: value
            })

            if (this.getFilters.kpi === 'requisitionsOpen' || this.getFilters.kpi === 'requisitionsOverdue') {
                this.setFilters({
                    page: 'requisitions',
                    filter: 'responsible',
                    value: this.userInfo.getUserId
                })
            }
        },
        removeAddressFilter () {
            this.removeFilters({
                filter: 'address',
                value: ''
            })
        },
        removeKPIFilter () {
            this.resetFilters('user')
        },
        removeRequisitionFilter (filter, value) {
            if (Array.isArray(this.getFilters.requisitions[filter]) && filter === 'responsible') {
                const element = this.$parent.$children.find(child => child.$options.name === 'dashboard-filters').$refs[`enquiry${filter[0].toUpperCase() + filter.slice(1)}`]

                if (element) {
                    element.checked = element.checked.filter(item => item.userId !== value)
                }
            }
            if (typeof this.getFilters.requisitions[filter] === 'string' && filter === 'name') {
                this.$parent.$children.find(child => child.$options.name === 'dashboard-filters').$refs.requisitionTaskNameSearch.value = ''
            }
            this.removeFilters({
                page: 'requisitions',
                filter: filter,
                value: value
            })
        },
        toggleView () {
            let mapInterval = null

            if (this.listingView === 'list') {
                this.listingView = 'map'
                this.getFilteredList()
                this.mapConfig = new NMapConfig()
                mapInterval = setInterval(() => {
                    let vectorLayer = this.mapConfig.layers.find(l => l.manager.name === 'vector')

                    if (vectorLayer) {
                        vectorLayer.on('hover', (event) => {
                            vectorLayer.popup = new NMapPopup({
                                mode: 'hover',
                                closeButton: false,
                                position: 'auto'
                            })

                            this.$refs.baseMap.$el.style.cursor = 'pointer'

                            let content = '<ul class="base-map-popup-list">'

                            event.feature.cargo.forEach((r) => {
                                content += `
                                    <li class="base-map-popup-item">
                                        <div class="base-map-popup-title">${r.taskName}</div>
                                        <div class="base-map-popup-status requisition-status ${this.statusColor(r.status)}">${r.status}</div>
                                    </li>
                                `
                            })

                            content += '</ul>'

                            vectorLayer.popup.content = content
                        })

                        vectorLayer.on('unhover', () => {
                            this.$refs.baseMap.$el.style.cursor = 'auto'
                        })

                        vectorLayer.on('select', (event) => {
                            // if (event.feature.cargo.length === 1) {
                            //     window.location.href = this.$router.resolve(`/entreprenoeropgave/${event.feature.cargo[0].id}`).href
                            // } else {
                            vectorLayer.popup = new NMapPopup({
                                mode: 'click',
                                closeButton: false,
                                autoClose: false
                            })

                            let content = '<ul class="base-map-popup-list">'

                            event.feature.cargo.forEach((r) => {
                                const href = this.$router.resolve(`/entreprenoeropgave/${r.id}`).href
                                content += `
                                    <li class="base-map-popup-item">
                                        <div class="base-map-popup-title">${r.taskName}</div>
                                        <div class="base-map-popup-status requisition-status ${this.statusColor(r.status)}">${r.status}</div>
                                        <a class="base-map-popup-item--link" href="${href}"></a>
                                    </li>
                                `
                            })

                            content += '</ul>'

                            vectorLayer.popup.content = content
                            // }
                        })

                        clearInterval(mapInterval)
                        this.updateMapFeatures()
                    }
                }, 100)
            } else {
                this.listingView = 'list'
                this.mapConfig = null
                clearInterval(mapInterval)
            }
        },
        updateMapFeatures () {
            let vectorLayer = this.mapConfig.layers.find(l => l.manager.name === 'vector')
            const mapItems = this.getRequisitionMapItems
            if (vectorLayer) {
                vectorLayer.clear()
                mapItems.forEach((mapItem) => {
                    mapItem.requisitions = JSON.parse(mapItem.requisitions)
                    try {
                        const cargo = []
                        mapItem.requisitions.forEach(mapItemR => {
                            console.log(mapItemR)
                            cargo.push({
                                // address: this.requisitions.find(r => r.requisitionId === mapItemR.requisitionId).address1,
                                taskName: mapItemR.taskName,
                                id: mapItemR.requisitionId,
                                status: mapItemR.status
                            })
                        })
                        const feature = new NMapFeature({
                            sourceType: 'coordinates',
                            source: new NMapCoordinates(mapItem.wkt, 'EPSG:25832'),
                            projection: 'EPSG:4326',
                            style: new NMapStyleIcon({
                                icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 48 48"><path fill="white" d="M24 4c-7.73 0-14 6.27-14 14 0 10.5 14 26 14 26s14-15.5 14-26c0-7.73-6.27-14-14-14zm0 19c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/></svg>',
                                color: '#5293bc',
                                anchor: [0.5, 1]
                            }),
                            cargo: cargo
                        })
                        vectorLayer.addFeature(feature)
                    } catch (e) {
                        console.error(e)
                    }
                })
            }
        }
    },
    mounted () {
        this.getFilteredList(true)
    }
}
</script>

<style lang="scss">
@import '../../../scss/utils/colors';
@import '../../../scss/utils/status-tag';

.map-button {
    background-color: #5293bc;
    border-radius: 50%;
    bottom: 15px;
    height: 55px;
    left: 15px;
    position: fixed;
    width: 55px;
    z-index: 9;

    &:hover {
        background-color: #2C3E50;
    }
}
.list-map-wrapper .dmap-window {
    border: 2px #efeded solid;
    height: 600px;
    position: relative;
    width: 100%;
    z-index: 0;
}
.nmap.nmap-popup {
    bottom: auto !important;
    left: calc(100% * var(--mouse-x)) !important;
    position: fixed;
    right: auto !important;
    top: calc(100% * var(--mouse-y) - 6px) !important;
    transform: translate(-50%, -100%);
    width: 288px;

    .requisition-status {
        @include status-tag;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/list/list-requisitions.vue